import React, { memo, useCallback } from "react";
import { Card } from "react-bootstrap";
import PropTypes from 'prop-types';
import { rgbaColor } from "helpers/utils";
import dayjs from "dayjs";
import { stillageTypes } from "services/stillageDashboard";
import { buildReqActWidgetTableRow, buildCollectionWidgetTableRow } from "services/stillageCollections";

const PositionWidget = ({ title, data, typeKey }) => {
    const type = stillageTypes[typeKey];
    const headers = [
        <th key="blank"></th>,
        ...(data && Array.isArray(data) ? data.map((x, i) => (
            <th key={x?.date || i} className="text-center">{dayjs(x.date).format('ddd D MMM')}</th>
        )) : []),
        <th key="totals">Totals</th>
    ];

    const buildReqActRow = useCallback((data, typeKey) => buildReqActWidgetTableRow(data, typeKey), []);
    const buildCollectionRow = useCallback((data, typeKey) => buildCollectionWidgetTableRow(data, typeKey), []);

    return (
        <Card className="shadow-sm mb-2">
            <Card.Header>
                <span className="float-start"><h5 className="text-600">{title}</h5></span>
                <span className='float-end' dangerouslySetInnerHTML={{ __html: type?.label }} />
            </Card.Header>
            <Card.Body className="overflow-auto">
                <table style={{ fontSize: 14 }} className="table table-sm table-responsive">
                    <thead style={{ backgroundColor: rgbaColor(type?.colour, .15) }}>
                        <tr>{headers}</tr>
                    </thead>
                    <tbody>
                        <tr className="table-light"><th><i>Useage</i></th><td colSpan={headers.length - 1}></td></tr>
                        <tr>{buildReqActRow(data, typeKey)}</tr>
                        <tr className="table-light"><th><i>Returns</i></th><td colSpan={headers.length - 1}></td></tr>
                        <tr>{buildCollectionRow(data, typeKey)}</tr>
                    </tbody>
                </table>
            </Card.Body>
        </Card>
    );
}

PositionWidget.propTypes = {
    data: PropTypes.array,
    title: PropTypes.string,
    typeKey: PropTypes.string
};

export default memo(PositionWidget);